//
// Route.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./LocationFeature";
import "./Pin";
import "@sas-dvr/ltjs-commons/maps/RouteInfo";

var Route = createModule("gtl::Route", ["gtl::LocationFeature"], EventDispatcher, [
    ,
    ,
    ,
    {
        arrowEnabled: 2,
        waypoints: [1],
    },
    {
        calculateRoute: [0,[1],1],
        getRouteInfo: [1],
        reset: [0],
        getDistanceString: [7],
        getTimeString: [7],
        getAppliedRouteInfo: [1],
    },
    ,
    ,
]);
export default Route;
